import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate, Link, useLocation } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";

const BackupCSHP = ({ packages, onPriceBackup }) => {
    const [showModal, setShowModal] = useState(false);
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [isSelected, setIsSelected] = useState(true);
    const [price, setPrice] = useState(0);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);




    useEffect(() => {
        const price = packages?.cshp_price_storage || 0;
        setPrice(price);
        onPriceBackup({ price: price, isSelected });
    }, [packages, isSelected]);  


    const handleConfirmDisable = () => {
        setShowModal(false);
        setCheckboxChecked(false);
        setIsSelected(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCheckboxChecked(false);
        setIsSelected(true);
    };

    const handleCardClick = () => {
        if (isSelected) {
            setShowModal(true);
        } else {
            setIsSelected(true);
        }
    };

    const handleCheckboxChange = (event) => {
        setCheckboxChecked(event.target.checked);
    };

    return (
        <div style={{ margin: 0, padding: 0 }} className="container mt-4">
            <div className="row">
                <div className="col-md-4 mb-3">
                    <div
                        className={`card ${isSelected ? "border-primary" : ""}`}
                        style={{
                            border: isSelected ? "2px solid #0069ff" : "1px solid #ccc",
                            height: "100%",
                            cursor: "pointer",
                        }}
                        onClick={handleCardClick}
                    >
                        <div className="card-body">

                            <h5
                                className="card-title d-flex justify-content-between"
                                style={{ fontSize: "1rem" }}
                            >
                                {t("Auto Backups")}
                                <span className="badge bg-primary" style={{ fontSize: "0.8rem" }}>
                                    Recommended
                                </span>
                            </h5>

                            <h6
                                className="card-subtitle mb-2 text-muted"
                                style={{ fontSize: "1rem" }}
                            >
                                {new Intl.NumberFormat("vi-VN", {

                                }).format(price)}/ {t("hour")}
                            </h6>

                            <p className="card-text" style={{ fontSize: "0.8rem" }}>
                                {t("Information_Backup")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", marginTop: "100px" }}
                    role="dialog"
                >
                    <div className="modal-dialog modal-lg" style={{ width: "50%" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {t("Title_Confirm_Backup")}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>{t("Title2_Confirm_Backup")}</p>
                                <ul>
                                    <li className="text-danger">
                                        {t("Content_1_Confirm_Backup")}
                                    </li>
                                    <li className="text-danger">
                                        {t("Content_2_Confirm_Backup")}
                                    </li>
                                    <li className="text-danger">
                                        {t("Content_3_Confirm_Backup")}
                                    </li>
                                </ul>
                                <div className="form-check mt-3">
                                    <input
                                        style={{ border: "1px solid black" }}
                                        type="checkbox"
                                        className="form-check-input"
                                        id="understandRisk"
                                        onChange={handleCheckboxChange}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="understandRisk"
                                    >
                                        {t("Check_Backup")}
                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    style={{
                                        backgroundColor: "#BE2E30",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        fontSize: "16px",
                                        cursor: checkboxChecked ? "pointer" : "not-allowed",
                                        opacity: checkboxChecked ? "1" : "0.6",
                                    }}
                                    disabled={!checkboxChecked}
                                    onClick={handleConfirmDisable}
                                >
                                    {t("Button_Confirm")}
                                </button>
                                <button
                                    type="button"
                                    style={{
                                        backgroundColor: "#007BFF",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleCloseModal}
                                >
                                    {t("Button_Cancel")}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BackupCSHP;
